import { useMediaQuery, Link } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Image from 'next/image';
import { useRouter } from 'next/navigation';
import React from 'react';
import { getRunTimeEnv } from '../../../util/getEnvVariable';
import getGeneralImage from '../../../util/getGeneralImage';
import { BLUR_DATA_URL } from '../../../util/imageConstants';

/**
 * @name BrandIcon
 * @description Logo of the website
 * @param {object} root0  - destructured object
 * @param {string} root0.icons - Data from Strapi
 * @returns {JSX.Element} Next.js Image Element
 */
const BrandIcon = ({ icons }) => {
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.down('md'));
  const router = useRouter();
  const clientSideEnv = getRunTimeEnv();
  /**
   * @name handleKeyDown
   * @param {object} event - event
   */
  const handleKeyDown = event => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      router.push(`${clientSideEnv.NEXT_PUBLIC_EIRIE || process.env.NEXT_PUBLIC_EIRIE}`);
    }
  };

  return (
    <Link
      href=''
      underline='none'
      onClick={() =>
        router.push(`${clientSideEnv.NEXT_PUBLIC_EIRIE || process.env.NEXT_PUBLIC_EIRIE}`)
      }
      onKeyDown={handleKeyDown}
    >
      <Image
        placeholder={'blur'}
        blurDataURL={BLUR_DATA_URL}
        width={sm ? 60 : 90}
        height={sm ? 45 : 63}
        src={`${
          getGeneralImage({
            generalImageArray: icons,
            key: 'BrandIcon',
            view: 'DesktopViewImage',
          }).url
        }`}
        alt='eir go back to the homepage'
        style={{ padding: '4px' }}
        quality={100}
      ></Image>
    </Link>
  );
};

BrandIcon.displayName = 'BrandIcon';
export default BrandIcon;
